const collectionHandle =
  document.querySelector("body").dataset.collectionHandle;
setupHoverImages();
function setupHoverImages() {
  $(".product-card .product__swatch-link").each(function () {
    $(this).click((e) => {
      e.preventDefault();
      if (
        $(window).width() > 1023 &&
        !document.body.hasAttribute("data-disable-tee-page")
      ) {
        window.location.href = $(this).attr("href");
      }
      $(this)
        .closest(".product-card")
        .find(".product__swatch")
        .removeClass("active");
      $(this).find(".product__swatch").addClass("active");
    });
  });

  document
    .querySelectorAll(".product-card .product__swatch-link")
    .forEach((swatch) => {
      const variantImg = swatch
        .closest(".product-card")
        .querySelector(
          ".product-card__variant-img[data-product='" +
            swatch.dataset.product +
            "']"
        );
      if (!variantImg) return;
      const variantAvailable = variantImg.dataset.available == "true";
      swatch.addEventListener("mouseenter", function () {
        if ($(window).width() > 1023) {
          variantImg.classList.remove("hidden");
          toggleSoldOut(swatch, variantAvailable);
        }
      });
      swatch.addEventListener("mouseleave", function () {
        if ($(window).width() > 1023) {
          variantImg.classList.add("hidden");
          $(swatch)
            .closest(".product-card")
            .find(".product-card__sold-out")
            .removeClass("invisible");
        }
      });
      $(swatch).click(function () {
        if ($(window).width() > 1023) return;
        swatch
          .closest(".product-card")
          .querySelectorAll(".product-card__variant-img")
          .forEach((el) => el.classList.add("hidden"));
        variantImg.classList.remove("hidden");
        toggleSoldOut(swatch, variantAvailable);
      });
    });

  function toggleSoldOut(swatch, variantAvailable) {
    if (variantAvailable) {
      $(swatch)
        .closest(".product-card")
        .find(".product-card__sold-out")
        .addClass("invisible");
    } else {
      $(swatch)
        .closest(".product-card")
        .find(".product-card__sold-out")
        .removeClass("invisible");
    }
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Modify Product Item",
      enabled: true,
      apply: () => ({
        beforeRender(element) {
          const item = element.getRootElm();
          if (
            item.classList.contains("product-card") ||
            !item.querySelector(".boost-sd__product-link") ||
            !item.querySelector(".boost-sd__product-link").href
          )
            return;
          const url =
            item.querySelector(".boost-sd__product-link").href +
            "?view=product-card";
          fetch(url)
            .then((res) => {
              if (res.status == 404) return null;
              return res.text();
            })
            .then((res) => {
              if (!res) return;
              const parser = new DOMParser();
              const doc = parser.parseFromString(res, "text/html");
              item.replaceWith(doc.querySelector("product-card"));
            });
        },
        afterRender(element) {},
      }),
    });
  },
]);

let editorialDesktop;
let editorialMobile;
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductList", {
      name: "Add Editorial",
      enabled: true,
      apply: () => ({
        beforeRender(element) {
          if (!collectionHandle) return;
          const rootElm = element.getRootElm();
          if (!rootElm.classList.contains("editorial-added")) {
            rootElm.classList.add("editorial-added");
            fetch("/collections/" + collectionHandle + "?view=editorial")
              .then((res) => res.text())
              .then((res) => {
                editorialMobile = document.createElement("div");
                editorialMobile.innerHTML = res;
                editorialMobile.classList.add("editorial-wrapper");
                editorialMobile.style.display = "contents";
                editorialMobile.classList.add("sm:hidden");

                editorialDesktop = document.createElement("div");
                editorialDesktop.innerHTML = res;
                editorialDesktop.classList.add("editorial-wrapper");
                editorialDesktop.style.display = "contents";
                editorialDesktop.classList.add("sm-max:hidden");
                addEditorialCards(rootElm);
              });
          } else {
            addEditorialCards(rootElm);
          }
        },
        afterRender(element) {},
      }),
    });
  },
]);

function addEditorialCards(rootElm) {
  const products = rootElm.querySelectorAll(".boost-sd__product-item");

  rootElm.querySelectorAll(".editorial-wrapper").forEach((el) => el.remove());

  if (products.length > 4 && editorialMobile)
    products[4].after(editorialMobile);
  if (products.length > 9 && editorialDesktop)
    products[9].after(editorialDesktop);
}

function setupProductCard(currentHTML, newHTML) {
  const tempEl = document.createElement("div");
  tempEl.innerHTML = newHTML;
  const currentEl = document.createElement("div");
  currentEl.innerHTML = currentHTML;

  const discountBadge = tempEl.querySelector(
    ".product-card__discount.first-variant"
  );
  const newBadgesList = tempEl.querySelectorAll(".product-card__badges");
  currentEl
    .querySelector(".boost-sd__product-link-image .boost-sd__product-image")
    .append(newBadgesList[0]);
  if (discountBadge) {
    currentEl
      .querySelector(".boost-sd__product-link-image .boost-sd__product-image")
      .append(discountBadge);
  }

  const newVariantImages = tempEl.querySelectorAll(
    ".product-card__image-container .product-card__variant-img"
  );
  currentEl
    .querySelector(".boost-sd__product-item-grid-view-layout-image")
    .append(...newVariantImages);

  currentEl
    .querySelector(".boost-sd__product-link-image")
    .append(tempEl.querySelector(".product-card__overlay"));

  currentEl
    .querySelector(".boost-sd__product-link-image")
    .append(tempEl.querySelector(".product-card-wishlist"));

  var newInfo = document.createElement("div");
  newInfo.innerHTML = tempEl.querySelector(
    ".product-card__text-content"
  ).innerHTML;
  if (currentEl.querySelector(".boost-sd__product-info")) {
    const currentInfo = currentEl
      .querySelector(".boost-sd__product-info")
      .closest(".boost-sd__product-link");
    currentInfo.remove();
    currentEl.append(newInfo);
  }

  return currentEl;
}

let toolbarScriptRunning = false;
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("Toolbar", {
      name: "Modify Toolbar",
      enabled: true,
      apply: () => ({
        beforeRender(element) {},
        afterRender(element) {
          if (toolbarScriptRunning) return;
          toolbarScriptRunning = true;
          const toolbar = element
            .getRootElm()
            .querySelector(".boost-sd__toolbar");
          const newDiv = document.createElement("div");
          newDiv.className = "filter-and-sort-badge";
          newDiv.innerHTML += `Filter & Sort <img src="https://cdn.shopify.com/s/files/1/0518/6281/files/Frame.png?v=1713518908" width=20 height=20>`;
          toolbar.append(newDiv);
          newDiv.addEventListener("click", () =>
            document
              .querySelector(".boost-sd__filter-tree-toggle-button")
              .click()
          );

          //find collection-editorial and move it below .boost-sd__toolbar-container
          const collectionEditorial = document.querySelector(
            "#shopify-section-editorial-banner"
          );
          if (collectionEditorial) {
            const toolbarContainer = document.querySelector(
              ".boost-sd__toolbar-container"
            );
            toolbarContainer.after(collectionEditorial);
          }

          fetch(
            "https://services.mybcapps.com/bc-sf-filter/filter?shop=mate-vintage-2.myshopify.com&build_filter_tree=true"
          )
            .then((res) => res.json())
            .then((res) => {
              const filterOptions = res.filter.options.map(
                (filter) => filter.label
              );
              const filterOptionsDiv = document.createElement("div");
              filterOptionsDiv.classList.add("filter-options");
              filterOptionsDiv.innerText = "Filter by:";

              filterOptions.forEach((option) => {
                const filterOption = document.createElement("div");
                filterOption.classList.add("filter-option");
                filterOption.innerHTML = option + " +";
                filterOptionsDiv.appendChild(filterOption);
              });

              toolbar.prepend(filterOptionsDiv);

              document.querySelectorAll(".filter-option").forEach((el) =>
                el.addEventListener("click", () => {
                  document
                    .querySelector(".boost-sd__filter-tree-toggle-button")
                    .click();
                })
              );
            });
        },
      }),
    });
  },
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("FilterTreeVertical", {
      name: "Modify Toolbar",
      enabled: true,
      apply: () => ({
        beforeRender(element) {},
        afterRender(element) {
          if (!collectionHandle) return;
          const treeList = element
            .getRootElm()
            .querySelector(".boost-sd__filter-tree-vertical-option-list");
          if (!treeList) return;
          if (treeList.querySelector(".boost-sort-by-filter")) return;
          fetch("/collections/" + collectionHandle + "?view=filter-sort-by")
            .then((res) => res.text())
            .then((res) => {
              const newEl = document.createElement("div");
              newEl.classList.add("boost-sd__filter-option");
              newEl.classList.add("custom__sort-section");
              newEl.innerHTML = res;
              treeList.prepend(newEl);
              setupSort();
            });
        },
      }),
    });
  },
]);

function setupSort() {
  const sortWrapper = document.querySelector(".custom__sort-section");
  const sortItems = sortWrapper.querySelectorAll("a");
  const url = new URL(window.location.href);
  const sort = url.searchParams.get("sort");
  const activeClass = "boost-pfs-filter-sort-item-active";
  if (sort) {
    sortItems.forEach((el) => el.classList.remove(activeClass));
    console.log(sort);
    sortWrapper
      .querySelector('a[data-sort="' + sort + '"]')
      .classList.add(activeClass);
  }
  sortItems.forEach((el) =>
    el.addEventListener("click", function (e) {
      e.preventDefault();
      document
        .querySelector(
          '.boost-sd__sorting-list li[data-value="' +
            e.target.dataset.sort +
            '"]'
        )
        .click();

      sortItems.forEach((el) => el.classList.remove(activeClass));
      el.classList.add(activeClass);

      setTimeout(() => {
        document
          .querySelector(".boost-sd__sorting-list")
          .classList.remove("boost-sd__sorting-list--active");
      }, 10);
    })
  );

  sortWrapper
    .querySelector(".boost-sd__filter-option-label")
    .addEventListener("click", function () {
      sortWrapper
        .querySelector(".boost-sd__filter-option-label")
        .classList.toggle("boost-sd__filter-option-label--collapsed");
      sortWrapper
        .querySelector(".boost-sort-by-filter")
        .classList.toggle("boost-sd__filter-option-itemwrapper--collapsed");
    });
}

document.body.addEventListener("update-cart", async function (t) {
  fetch("/cart?view=quantity-breaks")
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const quantityBreaks = doc.querySelector(".quantity-breaks-wrapper");
      document
        .querySelectorAll(".quantity-breaks-wrapper")
        .forEach((el) => (el.innerHTML = quantityBreaks.innerHTML));
    });
});

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  get formId() {
    return this.getAttribute("id");
  }

  get rowIndex() {
    return this.closest("[data-bundle-row-index]").dataset.bundleRowIndex;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.form = this.querySelector("form");
    this.masterSelect = this.querySelector("[name='id']");
    this.variants = JSON.parse(
      this.querySelector("[data-variants]").textContent
    );
    this.product = JSON.parse(this.querySelector("[data-product]").textContent);
    this.isBundleForm = this.form.dataset.formType === "bundle-card-form";
    this.atcButton = this.querySelector("[data-atc-button]");
    this.addingText = this.querySelector("[data-adding-text]");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.addEventListener("add-to-cart", this.handleSubmit.bind(this));
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.masterSelect.value = variant.id;
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isBundleForm) {
      this.addToBundle();
    } else {
      this.submit();
    }
  }

  addToBundle() {
    const variant = this.variants.find(
      (variant) => variant.id == this.masterSelect.value
    );
    const rowIndex = this.rowIndex;

    const imageUrl = variant.featured_image
      ? variant.featured_image
      : this.product.featured_image;

    this.dispatchEvent(
      new CustomEvent("addToBundle", {
        detail: {
          variant: {
            id: variant.id,
            imageUrl,
            title: variant.title,
            price: variant.price,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            options: variant.options,
          },
          product: this.product,
          rowIndex,
        },
        bubbles: true,
      })
    );
  }

  submit() {
    const formData = new FormData(this.form);
    formData.append('id', this.masterSelect.value);
    formData.append('quantity', 1);

    if (this.addingText) {
      this.addingText.classList.remove("hidden");
    }
    fetch("/cart/add.js", {
      method: "POST",
      body: formData
    })
      .then(() => {
        window.theme.reloadCart();
        this.dispatchEvent(new Event("item:added", { bubbles: true }));
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (this.addingText) {
          this.addingText.classList.add("hidden");
        }
      });
  }
}

if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm);
}

class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variants = JSON.parse(
      this.querySelector("[data-variants]").textContent
    );
    this.currentVariant = null;
    this.optionInputs = this.querySelectorAll("input");
    this.linkedProductInputs = this.querySelectorAll(
      "[data-linked-product-url]"
    );
    this.bindEvents();
  }

  bindEvents() {
    this.listenToChange();
    this.linkedProductInputs.forEach((input) =>
      input.addEventListener("click", this.linkedProductClick.bind(this))
    );
  }

  linkedProductClick(e) {
    e.preventDefault();
    this.dispatchEvent(
      new CustomEvent("linked-product-change", {
        detail: { productUrl: e.target.dataset.linkedProductUrl },
        bubbles: true,
      })
    );
  }

  listenToChange() {
    this.optionInputs.forEach((input) =>
      input.addEventListener(
        "change",
        this.updateCurrentVariant.bind(this, input)
      )
    );
  }

  updateCheckedInputs() {
    this.optionInputs.forEach((input) => {
      if (input.checked) {
        input.setAttribute("checked", "checked");
      } else {
        input.removeAttribute("checked");
      }
    });
  }

  getSelectedValues() {
    return Array.from(this.querySelectorAll("input:checked")).reduce(
      (acc, input) => {
        acc[input.name] = input.value;
        return acc;
      },
      {}
    );
  }

  updateCurrentVariant(input = null) {
    const isAddOnClick = input?.dataset.addOnClick == "true";
    this.updateCheckedInputs();
    const selectedValues = this.getSelectedValues();

    this.currentVariant =
      this.variants.find((variant) => {
        return Object.entries(selectedValues).every(([name, value]) => {
          return variant[name] === value;
        });
      }) || null;

    this.querySelectorAll(".variant-picker__option").forEach((optionEl) => {
      const valueDisplay = optionEl.querySelector("[data-option-name-value]");
      const selectedInput = optionEl.querySelector("input:checked");

      if (selectedInput) {
        valueDisplay.textContent = selectedInput.value;
      }
    });

    if (this.currentVariant) {
      this.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
          },
          bubbles: true,
        })
      );
    }

    if (isAddOnClick) {
      this.dispatchEvent(
        new CustomEvent("add-to-cart", {
          bubbles: true,
        })
      );
    }
  }
}

if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}

class BundleBuilder extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.numberOfRows = this.dataset.numberOfRows;
    this.chosenVariants = Array.from({
      length: parseInt(this.numberOfRows),
    }).reduce((acc, _, i) => {
      acc[i] = null;
      return acc;
    }, {});
    this.atcButtons = this.querySelectorAll("[data-bundle-add-product]");
    this.bundleVariantId = this.dataset.bundleVariantId;
    this.resetBundleButtons = this.querySelectorAll("[data-reset-bundle]");
    this.chosenProductRows = this.querySelectorAll("[data-row-chosen-product]");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("addToBundle", (e) => this.addToBundle(e));
    this.querySelectorAll("[data-bundle-remove-product]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        const rowIndex = e.target.closest("[data-row-chosen-product]").dataset
          .rowChosenProduct;
        this.removeFromBundle(rowIndex);
      });
    });
    this.resetBundleButtons.forEach((el) =>
      el.addEventListener("click", this.resetBundle.bind(this))
    );
    this.atcButtons.forEach((el) =>
      el.addEventListener("click", this.addBundleToCart.bind(this))
    );
    this.chosenProductRows.forEach((el) =>
      el.addEventListener("click", () => this.handleEmptyCardClick(el))
    );
  }

  handleEmptyCardClick(el) {
    const rowIndex = el.dataset.rowChosenProduct;
    this.focusRow(rowIndex);
  }

  focusRow(rowIndex) {
    const allRows = this.querySelectorAll("[data-bundle-row-index]");
    allRows.forEach((r) => {
      const details = r.querySelector("details");
      if (details) {
        details.open = r.dataset.bundleRowIndex == rowIndex;
      }
    });
    this.closeMobileOverview();
    const row = this.querySelector(`[data-bundle-row-index="${rowIndex}"]`);

    if (row) {
      const rect = row.getBoundingClientRect();
      const isDesktop = window.matchMedia("(min-width: 48em)").matches;
      const offset = isDesktop ? 168 : 68;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      window.scrollTo({
        top: scrollTop + rect.top - offset,
        behavior: "smooth",
      });
    }
  }

  resetBundle() {
    this.chosenVariants = Array.from({
      length: parseInt(this.numberOfRows),
    }).reduce((acc, _, i) => {
      acc[i] = null;
      return acc;
    }, {});
    this.render();
  }

  closeMobileOverview() {
    this.querySelector("bundle-overview-mobile")?.close();
  }

  addBundleToCart() {
    const chosenVariantCount = Object.values(this.chosenVariants).filter(
      Boolean
    ).length;
    if (chosenVariantCount < this.numberOfRows) {
      this.closeMobileOverview();
      return;
    }
    const bundleVariantId = Number(this.bundleVariantId);
    const uniqueBundleId =
      Date.now() + "-" + Math.random().toString(36).substring(2, 11);
    const items = Object.values(this.chosenVariants)
      .filter(Boolean)
      .map((variantAndProduct) => {
        const variant = variantAndProduct.variant;
        return {
          id: variant.id,
          quantity: 1,
          properties: {
            _bundleGroupId: uniqueBundleId,
            _bundleVariantId: bundleVariantId,
          },
        };
      });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then(window.theme.reloadCart)
      .catch((err) => {
        console.error(err);
      });
  }

  addToBundle(e) {
    const variant = e.detail.variant;
    const product = e.detail.product;
    const rowIndex = e.detail.rowIndex;
    this.chosenVariants[rowIndex] = { variant, product };
    this.render();
    this.focusRow(Number(rowIndex) + 1);
  }

  removeFromBundle(rowIndex) {
    this.chosenVariants[rowIndex] = null;
    this.render();
  }

  render() {
    this.renderCardButtons();
    this.renderChosenProducts();
    this.renderTotal();
    this.renderButton();
  }

  renderCardButtons() {
    const productCards = document.querySelectorAll(
      "product-card[data-product-id]"
    );
    const chosenProductIds = Object.values(this.chosenVariants)
      .filter((item) => item !== null)
      .map((item) => item.product.id.toString());

    productCards.forEach((card) => {
      const productId = card.dataset.productId;
      const atcButton = card.querySelector("[data-atc-button]");

      if (atcButton) {
        atcButton.classList.toggle(
          "added",
          chosenProductIds.includes(productId)
        );
      }
    });
  }

  renderChosenProducts() {
    this.querySelectorAll("[data-row-chosen-product]").forEach((el) => {
      const rowIndex = el.dataset.rowChosenProduct;
      const variantAndProduct = this.chosenVariants[rowIndex];
      const titleAndOptions = el.querySelector("[data-title-and-options]");
      const innerContent = el.querySelector("[data-inner-content]");
      if (!variantAndProduct) {
        innerContent.innerHTML = el.querySelector("[data-title]").dataset.title;
        titleAndOptions.innerHTML = "";
        return;
      }
      const variant = variantAndProduct.variant;
      const product = variantAndProduct.product;

      innerContent.innerHTML = `<img src="${variant.imageUrl}" alt="${variant.title}" />`;
      el.querySelector("[data-bundle-remove-product]").classList.toggle(
        "hidden",
        !variant
      );

      titleAndOptions.innerHTML = this.renderTitleAndOptions(product, variant);
    });
  }
  renderTitleAndOptions(product, variant) {
    const optionNames = product.options.split(",");
    return `<div class="bundle-chosen-product-title">${product.title}</div>
    ${optionNames
      .map(
        (option, index) =>
          `<p class="bundle-chosen-product-option">${option}: ${variant.options[index]}</p>`
      )
      .join("")}`;
  }

  renderTotal() {
    const total = Object.values(this.chosenVariants).reduce(
      (acc, variantAndProduct) => {
        if (!variantAndProduct) return acc;
        const variant = variantAndProduct.variant;
        const price = variant.price;
        const quantity = 1;
        return acc + price * quantity;
      },
      0
    );

    this.updateAllEls(
      "[data-bundle-final-price]",
      Shopify.formatMoney(total * 0.8, window.theme.moneyFormatNoTrailingZeros)
    );
    this.updateAllEls(
      "[data-bundle-original-price]",
      Shopify.formatMoney(total, window.theme.moneyFormatNoTrailingZeros)
    );
  }

  renderButton() {
    const disabled = Object.values(this.chosenVariants).some(
      (variant) => !variant
    );

    this.atcButtons.forEach((el) => el.classList.toggle("disabled", disabled));
  }

  updateAllEls(selector, value) {
    this.querySelectorAll(selector).forEach((el) => {
      el.innerHTML = value;
    });
  }
}

if (!window.customElements.get("bundle-builder")) {
  window.customElements.define("bundle-builder", BundleBuilder);
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener("linked-product-change", (e) => {
      this.handleProductChange(e);
    });
    this.quickViewElement = this.querySelector("quick-view");
    this.quickAddElement = this.querySelector("quick-add");
    this.templateName = this.dataset.template ?? "product-card";
    this.quickAddTriggerElement = this.querySelector(
      "[data-quick-add-trigger]"
    );
    if (this.quickViewElement) {
      this.querySelectorAll(".product-card-gallery__image-container").forEach(
        (el) => {
          el.addEventListener("click", (e) => {
            e.preventDefault();
            this.quickViewElement.classList.add("active");
          });
        }
      );
    }
    if (this.quickAddElement && this.quickAddTriggerElement) {
      this.quickAddTriggerElement.addEventListener("click", (e) => {
        e.preventDefault();
        this.quickAddElement.classList.add("active");
      });
    }
  }

  handleProductChange(e) {
    const productUrl = e.detail.productUrl;
    this.classList.add("loading");
    fetch(productUrl + "?view=" + this.templateName)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const productCard = doc.querySelector("product-card");
        this.innerHTML = productCard.innerHTML;
        this.classList.remove("loading");
        this.init();
      });
  }
}

if (!window.customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
class ProductCardGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
    this.initHoverBehavior();
  }

  initHoverBehavior() {
    if (window.innerWidth < 767) return;
    this.addEventListener("mouseenter", () => {
      if (this.swiper && this.swiper.slides.length > 1) {
        this.swiper.slideTo(1);
      }
    });

    this.addEventListener("mouseleave", () => {
      if (this.swiper && this.swiper.slides.length > 0) {
        this.swiper.slideTo(0);
      }
    });
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
    });
  }
}

if (!window.customElements.get("product-card-gallery")) {
  customElements.define("product-card-gallery", ProductCardGallery);
}

class PageOverlay extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener("click", () =>
      document.dispatchEvent(new CustomEvent("overlay:click"))
    );
  }
}

if (!window.customElements.get("page-overlay")) {
  customElements.define("page-overlay", PageOverlay);
}

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    document.addEventListener("overlay:click", () =>
      this.classList.remove("active")
    );

    this.querySelector("[data-close-quickview]").addEventListener("click", () =>
      this.close()
    );

    this.addEventListener("addToBundle", () => this.classList.remove("active"));

    this.addEventListener("linked-product-change", (e) => {
      e.stopPropagation();
      this.handleProductChange(e);
    });
  }

  close() {
    this.classList.remove("active");
  }

  handleProductChange(e) {
    const productUrl = e.detail.productUrl;
    this.classList.add("loading");
    fetch(productUrl + "?view=quickview")
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const quickView = doc.querySelector("quick-view");
        quickView.classList.add("active");
        this.replaceWith(quickView);
      });
  }
}

if (!window.customElements.get("quick-view")) {
  customElements.define("quick-view", QuickView);
}

class QuickViewGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1.4,
      spaceBetween: 10,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
    });
  }
}

if (!window.customElements.get("quickview-gallery")) {
  customElements.define("quickview-gallery", QuickViewGallery);
}

class QuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    document.addEventListener("scroll", () => this.classList.remove("active"));
    this.addEventListener("item:added", () => this.classList.remove("active"));
  }
}

if (!window.customElements.get("quick-add")) {
  customElements.define("quick-add", QuickAdd);
}

class BuyButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.atcButton = this.querySelector("[data-atc-button]");
    this.isBundle = this.hasAttribute("data-bundle-card");
  }
}

if (!window.customElements.get("buy-buttons")) {
  customElements.define("buy-buttons", BuyButtons);
}

class BundleOverviewMobile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.summaryToggle = this.querySelector("[data-summary-toggle]");
    this.summaryToggle.addEventListener("click", this.toggleSummary.bind(this));
  }

  toggleSummary() {
    this.classList.toggle("active");
  }

  close() {
    this.classList.remove("active");
  }
}

if (!window.customElements.get("bundle-overview-mobile")) {
  customElements.define("bundle-overview-mobile", BundleOverviewMobile);
}
